import raf from 'raf'

const duration = 300

const easing = progress => 1 - Math.pow(1 - progress, 2)

let startTime = null
let startPosition = null
let targetPosition = null

const scroll = () => {
    const nowTime = Date.now()
    const progress = Math.min(1, (nowTime - startTime) / duration)

    const easedProgress = easing(progress)

    const distance = targetPosition - startPosition
    const position = startPosition + distance * easedProgress

    window.scrollTo(0, position)

    if (progress < 1) {
        raf(scroll)
    }
}

export default targetY => {
    startPosition = window.pageYOffset
    targetPosition = targetY
    startTime = Date.now()

    raf(scroll)
}


// WEBPACK FOOTER //
// ./src/utils/scroller.js